import axios from '../axios';
import config from "../../../config";
import PartnerDetails from "../classes/PartnerDetails";
import EventDetails from "../classes/EventDetails";

export default {
    getEventDetails(params) {
        const parameters = params || {};
        return axios.get(config.host + '/events/EventsDetails',{
            params:parameters
            })
            .then(resp => {
                return resp.data.Data.map(p => new EventDetails(p));
            })
    },
    addCallout(callout){
        return axios.post(config.host+'/events/AddNewCallout',{
            Partner_ID :callout.Partner_ID,
            Contact_ID :callout.Contact_ID,
            Branch_ID: callout.Branch_ID,
            Project_ID: callout.Project_ID,
            CalloutDescription:callout.CalloutDescription,
            Stopped:callout.Stopped || false,
            WhoAnnounced:callout.WhoAnnounced || "",
        }).then(resp=>resp.data.Data)

    }
}
